import history from './history';

const BASE_URL = 'http://localhost:3003';

let controller = new AbortController();

async function handleResponse(response) {
  const data = await response.json();

  if (!response.ok) {
    if (data?.errorType === 'invalid_token' || data?.errorType === 'token_not_sent') {
      history.push('/');
    }

    let message;
    
    if (data.responseCode === "N013") {
      message = 'abortPinpad';
    } else if (data.responseCode === "N012") {
      message = 'timeAbort';
    } else if (data.responseCode === "DECL") {
      message = 'autodefRun';
    } else if (data.responseCode === "N068") {
      message = 'autodefRun';
    } else {
      message = 'Erro desconhecido';
    }
    
    const error = new Error(message);
    error.response = data;

    throw error;
  }
  return data;
}

async function fetchWithTimeout(url, options = {}) {
  controller = new AbortController();
  let abortType = 'manualAbort';

  // const timeoutId = setTimeout(() => {
  //   controller.abort();
  //   abortType = 'timeAbort';
  // }, timeout);

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    });

    return response;
  } catch(e) {
    throw new Error(abortType);
  } finally {
    // clearTimeout(timeoutId);
  }
}

export function cancelPayPinpad() {
  if (controller) {
    controller.abort();
  }
}

export async function payPinpad(
  payload, 
  updateCurrentStatus, 
  updatePinpadPaymentError,
) {
  updateCurrentStatus('loading');
  const { 
    paymentMethod, 
    amount,
  } = payload;

  if (
    paymentMethod !== 'credit' &&
    paymentMethod !== 'debit' &&
    paymentMethod !== 'pix'
  ) {
    updatePinpadPaymentError('invalidMethod');
  }

  if (amount === 0) {
    updatePinpadPaymentError('invalidAmount');
  }

  try {
    const response = await fetchWithTimeout(`${BASE_URL}/pay-v2`, {
      method: 'POST',
      signal: controller.signal,
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    }, 1000 * 6 * 2);

    const handleRes = await handleResponse(response);
    const data = handleRes.data;

    if (data) {
      if (handleRes.serverNotificationError) {
        updatePinpadPaymentError('unsaved');
        updateCurrentStatus('unsaved');
      } else {
        updateCurrentStatus('success');
      }
    } else {
      updateCurrentStatus('error');
    }
  } catch (e) {
    updateCurrentStatus('error');
    updatePinpadPaymentError(e.message);
  }
}

export async function healthPinpad() {
  try {
    const response = await fetchWithTimeout(`${BASE_URL}/health`, {
      method: 'GET',
      signal: controller.signal,
    }, 30000);

    return await handleResponse(response);
  } catch (e) {
    throw new Error(e.message);
  }
}